export function descending<T>(callback: (item: T) => any)
{
    return function(a: T, b: T): 1 | -1 | 0
    {
        // Get the values using the provided callback function
        const valueA = callback(a);
        const valueB = callback(b);
        
        // Compare the values in descending order
        if (valueA < valueB)
        {
            return 1;
        }
        
        if (valueA > valueB)
        {
            return -1;
        }
        
        return 0;
    };
}

export function ascending<T>(callback: (item: T) => any)
{
    return function(a: T, b: T): 1 | -1 | 0
    {
        // Get the values using the provided callback function
        const valueA = callback(a);
        const valueB = callback(b);
        
        // Compare the values in descending order
        if (valueA > valueB)
        {
            return 1;
        }
        
        if (valueA < valueB)
        {
            return -1;
        }
        
        return 0;
    };
}

export function AppendPath(url: URL, path: string): URL
{
    const newUrl = new URL(url.href);

    // remove / from path
    if (path.startsWith('/'))
    {
        path = path.substring(1);
    }
  
    // Ensure the path does not end with a slash, if the current path has one
    if (!newUrl.pathname.endsWith('/'))
    {
        newUrl.pathname += '/' + path;
    }
    else
    {
        newUrl.pathname += path;
    }
  
    return newUrl;
}

export function ToFormData(obj: any, formData: FormData = new FormData(), parentKey: string = ''): FormData
{
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const formKey = parentKey ? `${parentKey}.${key}` : key;

            // If the value is an array, handle it by appending each item with an index
            if (Array.isArray(obj[key])) {
                obj[key].forEach((item: any, index: number) => {
                    ToFormData({ [`${key}[${index}]`]: item }, formData, parentKey);
                });
            }
            // If the value is an object, handle it recursively
            else if (obj[key] && typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
                ToFormData(obj[key], formData, formKey);
            } else {
                // Append primitive values (string, number, etc.)
                formData.append(formKey, obj[key]);
            }
        }
    }
    return formData;
}

export function imageLink(link: string): string {
    if (!link)
    {
        return "";
    }

    if (link?.startsWith("http"))
    {
      return link;
    }
    
    return "images/games/" + link;
}